import { Col } from 'react-bootstrap'
import Label from 'lib/Label'
import "./index.scss"

const SubHeader = ({ label, sublabel,size,label_style}) => {
  return (
    <div className={`${size}`} >
      {sublabel ? <p className={`subLabel fs-17px fw-semibold mb-1 ${label_style || ""}`}>{sublabel}</p> : ""}
    </div>
  );
};

export default SubHeader